import { Modal, Form, Input, Icon, Alert } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'

const FormItem = Form.Item

function EditTenantComponent(props) {
  const { form, editingRecord, loading, ...rest } = props
  const { getFieldDecorator } = form

  return (
    <Modal
      centered
      title="Change the chatbot organization"
      okText="Change"
      okButtonProps={{ loading: props.loading }}
      {...rest}>
      <Form layout="vertical">
        <FormItem label="New organization">
          {getFieldDecorator('organization', {
            rules: [
              {
                required: true,
              }
            ]
          })(<Input placeholder="take" prefix={<Icon type="bank" style={{ color: 'rgba(0,0,0,.25)' }} />}/>)}
        </FormItem>
      </Form>
      <Alert
        message="Careful!"
        description="This action will affect the payment account, cluster and throughput configurations!"
        type="warning"
        showIcon
      />
    </Modal>
  )
}

export const EditTenantModal = Form.create({
  mapPropsToFields: ({ record }) => Object.keys(record || {}).reduce((xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }), {}),
})(toClass(EditTenantComponent))

EditTenantComponent.propTypes = {
  record: PropTypes.object,
  form: PropTypes.any,
  editingRecord: PropTypes.object,
  loading: PropTypes.bool,
}
